import React from "react";
import { Input, Select } from "antd";
import Label from "./Label";
import InputField from "./InputField";
import { COUNTRY_CODES } from "../../../../assets/commonFunctions/CommonFunction";

const { Option } = Select;



const CustomPhoneInput = ({
  controlId,
  style,
  labelText,
  isCompulsary = false,
  value = "",
  onChange,
  onBlur,
  errorMessage,
  placeholder = "Enter phone number",
  isReadOnly = false,
  countryCode = "+91",
}) => {
  // Parse existing value to separate country code and number
  const parsePhoneValue = (phoneValue) => {
    if (!phoneValue) return { code: countryCode, number: "" };

    // Find matching country code
    const matchedCountry = COUNTRY_CODES.find((c) =>
      phoneValue.startsWith(c.code)
    );

    if (matchedCountry) {
      return {
        code: matchedCountry.code,
        number: phoneValue.slice(matchedCountry.code.length),
      };
    }

    return { code: countryCode, number: phoneValue };
  };

  const { code: selectedCode, number: phoneNumber } = parsePhoneValue(value);

  const handleCodeChange = (newCode) => {
    const fullNumber = `${newCode}${phoneNumber}`;
    onChange(fullNumber);
  };

  const handleNumberChange = (e) => {
    const newNumber = e.target.value.replace(/\D/g, ""); // Only allow digits
    const fullNumber = `${selectedCode}${newNumber}`;
    onChange(fullNumber);
  };

  const selectBefore = (
    <Select
      value={selectedCode}
      onChange={handleCodeChange}
      disabled={isReadOnly}
      className="phone-code-select"
      dropdownClassName="phone-code-dropdown"
      showSearch={false}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
      onInputKeyDown={(e) => {
      e.preventDefault();
    }}

    >
      {COUNTRY_CODES.map((country) => (
        <Option key={`${country.code}-${country.country}`} value={country.code}>
          <span className="country-option">
            <span className="country-code">{country.code}</span>
          </span>
        </Option>
      ))}
    </Select>
  );

  return (
    <div div style={style} className="custom-field-wrapper">
      {labelText && (
        <Label
          className={"custom-label"}
          labelText={labelText}
          isCompulsary={isCompulsary}
        />
      )}
      <div className="phone-input-container">
        <div className="phone-input-group">
          <div
            className={`phone-code-addon ${errorMessage ? "input-error" : ""}`}
          >
            {selectBefore}
          </div>
          <InputField
            controlId={controlId}
            controlName={controlId}
            placeholder={placeholder}
            inputType="text"
            value={phoneNumber}
            handleInputChange={handleNumberChange}
            handleBlur={onBlur}
            isReadOnly={isReadOnly}
            maxLength={15}
            errorMessage={errorMessage}
            suffixIcon={null}
            customClassName={"phone-field-input"}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomPhoneInput;
